import { CloseIcon } from '../../../assets/icons/Svg'
import { useDispatch, useSelector } from 'react-redux';
import { clearTypeModal, clearTypeOfCategory, clearTypeOfShowModalType, selectCategoryName } from '../../../features/modal/modalSlice';

export default function CategoryAndProductHeader() {

    const dispatch = useDispatch()
    const typeCategory = useSelector(selectCategoryName);

    const handleCloseCategoryAndProduct = () => {
        dispatch(clearTypeOfCategory());
        dispatch(clearTypeModal());
        dispatch(clearTypeOfShowModalType());
    }

    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                    {typeCategory}
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={handleCloseCategoryAndProduct}
                >
                    <CloseIcon/>
                </button>
            </div>
        </div>
    )
}
